import { render } from "./AddComp.vue?vue&type=template&id=df446c38&scoped=true"
import script from "./AddComp.vue?vue&type=script&lang=js"
export * from "./AddComp.vue?vue&type=script&lang=js"

import "./AddComp.vue?vue&type=style&index=0&id=df446c38&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df446c38"]])

export default __exports__